const breakpoints = {
  sm: "30em",
  md: "54em",
  lg: "62em",
};

export default breakpoints;
